<template>
<div class="component" v-if="scheduledDate && showComponent && !optedToClose">
    <span>Planned maintenance is scheduled for <strong>{{ formattedDate }}</strong>.</span>
    <span>This should take less than 15 minutes.</span>
    <span>We apologize for any inconvenience this may cause.</span>

    <span class="close-icon" title="Close" @click="optedToClose = true">
        <i class="material-icons">close</i>
    </span>
</div>
</template>

<script>
import dayjs from "dayjs"

export default {
    name: "scheduled-maintenance-message",

    props: {
        scheduledDate: {
            type: String
        }
    },

    data () {
        return {
            optedToClose: false,
            showComponent: false
        }
    },

    computed: {
        formattedDate () {
            const scheduledDate = dayjs(this.scheduledDate)

            if (!scheduledDate.isValid()) {
                return null
            }

            return `${scheduledDate.format("M/DD/YYYY")} at ${scheduledDate.format("h:mm A")}`
        }
    },

    watch: {
        scheduledDate (newValue) {
            if (newValue !== null) {
                const now = new Date()
                const scheduledDate = new Date(newValue)

                this.showComponent = now < scheduledDate
            }
        }
    }
}
</script>

<style scoped>
.component {
    background: #ffffff;
    border: 1px solid #b7b7b7;
    box-shadow: 0px 0px 10px #d9d9d9;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: calc(100% - 30px);
    padding: 10px 35px 10px 15px;
    position: fixed;
    right: 40px;
    text-align: center;
    top: 15px;
    width: 500px;
    z-index: 100;
}

.close-icon {
    cursor: pointer;
    line-height: 1;
    padding: 3px;
    position: absolute;
    right: 2px;
    top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/ScheduledMaintenanceMessage.vue